import {
  REQUEST_MARKDOWN_PENDING,
  REQUEST_MARKDOWN_SUCCESS,
  REQUEST_MARKDOWN_FAILED
} from '../constants/Constants';

const initialState = {
  data: [],
  isPending: true
}

export const getMarkdown = (state = initialState, action = {}) => {
  switch (action.type) {
      case REQUEST_MARKDOWN_PENDING:
          return Object.assign({}, state, { isPending: true });
      case REQUEST_MARKDOWN_SUCCESS:
          return Object.assign({}, state, { data: action.payload, isPending: false });
      case REQUEST_MARKDOWN_FAILED:
          return Object.assign({}, state, { error: action.payload });
      default:
          return state;

  }
}